import { useMemo } from 'react';
import { IsInvcGLCodeNotesRequired } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';

export interface GlBreakOutError {
  notes: string[];
  glCode: string[];
}

export interface GlBreakOutWarning {
  amount: string[];
}

const defaultGlBreakOutError: GlBreakOutError = {
  notes: [],
  glCode: [],
};

const defaultGlBreakOutWarning: GlBreakOutWarning = {
  amount: [],
};

const useInvoiceGlBreakoutErrors = (glBreakouts: InvoiceGlBreakoutItem[]) => {
  const isNotesRequired = usePermission({ permissions: IsInvcGLCodeNotesRequired });
  const errors = useMemo(
    () =>
      glBreakouts.map((glBreakout) => {
        let errs: GlBreakOutError = { ...defaultGlBreakOutError };

        if (glBreakout.glLabel === 'Totals:') {
          return errs;
        }

        if (isNotesRequired && !glBreakout.notes && glBreakout.glSubTotal) {
          errs.notes = ['GL Code Notes are required on the document.'];
        }
        if (glBreakout.notes?.length > 100) {
          errs.notes = ['GL Code Notes are more than 100 characters'];
        }
        if (!glBreakout.glCode) {
          errs.glCode = ['GL Code is required in GL Distribution Summary'];
        }

        return errs;
      }, []),
    [glBreakouts, isNotesRequired]
  );

  const warnings = useMemo(
    () =>
      glBreakouts.map((glBreakout) => {
        let warning: GlBreakOutWarning = { ...defaultGlBreakOutWarning };
        if (
          glBreakout.isNewlyAdded &&
          !glBreakout.discountAmt &&
          !glBreakout.salesTaxAmt &&
          !glBreakout.shipCostAmt
        ) {
          warning.amount = ['Add discount, shipping or tax amount'];
        }
        return warning;
      }),
    [glBreakouts]
  );

  return { errors, warnings };
};

export default useInvoiceGlBreakoutErrors;
